import { Injectable, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OAuthService, OAuthStorage } from 'angular-oauth2-oidc';
import { EncryptJwtService } from '../token-encryptor';
import { isValidReturnUrl } from '../url-validator';

@Injectable()
class PermissionsService {
  public constructor(
    private readonly oAuthService: OAuthService, private readonly oAuth: OAuthStorage) { }
  canActivate(): boolean {
    if (this.oAuthService.hasValidIdToken()) {
      return true;
    } else {
      this.oAuthService.initLoginFlow();
      return false;
    }
  }

}

export const authGuard: CanActivateFn = async (route, state) => {
  const oAuthService = inject(OAuthService);
  const oAuth = inject(OAuthStorage);
  const tokenEncryptor = inject(EncryptJwtService);
  let HostURL = JSON.parse(JSON.stringify(sessionStorage.getItem('deviceHost')));
  const id_token = oAuthService.getIdToken();
  if (oAuthService.getIdentityClaims()) {
    const claims = oAuthService.getIdentityClaims() as {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [key: string]: any;
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const sub = claims['sub'];
    if (sub.length > 0 ) {
      if (HostURL && isValidReturnUrl(HostURL)) {
        const encryptedToken = await tokenEncryptor.encryptJwt(id_token);
        sessionStorage.clear();
        window.location.href = HostURL + '?deviceHost=' + encryptedToken;
      }
      return true;
    }
    else {
      return false;
    }

  }
  else {
    sessionStorage.setItem('postLoginRedirect', state.url);
    oAuthService.initLoginFlow();
    return false;
  }
};
